(() => window.addEventListener('load', () => {
	Array.from(document.querySelectorAll('.sitemap-arrowup-img')).map(el => el.setAttribute('hidden', 'true'))
	const siteMapArray = Array.from(document.querySelectorAll("p.sitemap-toggle-menu"))
	siteMapArray.map(el => {
		el.addEventListener('click', () => {
			if(window.innerWidth > 1024) return
			Array.from(el.querySelectorAll('.sitemap-arrowdown-img, .sitemap-arrowup-img')).map(el => el.toggleAttribute('hidden'))
			el.nextElementSibling.style.display = el.nextElementSibling.style.display === 'block' ? 'none' : 'block'
		})
	});
	window.matchMedia("(min-width: 1024px)").addEventListener('change', ({matches}) => {
		siteMapArray.map(el => el.nextElementSibling.style.display = matches ? "block" : 'none')
		if(matches) {
			Array.from(document.querySelectorAll('.sitemap-arrowdown-img, .sitemap-arrowup-img')).map(el => el.setAttribute('hidden', 'true'))
		} else {
			Array.from(document.querySelectorAll('.sitemap-arrowdown-img')).map(el => el.removeAttribute('hidden'))
		}
	})
}))()